import { useState, useEffect, useCallback } from 'react';
import { getTheme, setTheme as persistTheme } from '../utils/preferences';

export function useTheme() {
  const [theme, setThemeState] = useState<'light' | 'dark'>(getTheme);
  const isDark = theme === 'dark';

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    const handleThemeChange = (e: Event) => {
      const ev = e as CustomEvent<{ theme: 'light' | 'dark' }>;
      if (ev.detail?.theme) setThemeState(ev.detail.theme);
    };
    window.addEventListener('themeChanged', handleThemeChange);
    return () => window.removeEventListener('themeChanged', handleThemeChange);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    const next = theme === 'dark' ? 'light' : 'dark';
    persistTheme(next);
    setThemeState(next);
  }, [theme]);

  return { toggleTheme, isDark };
}
